import ky from 'ky'

const API_BASE_URL = 'https://api.customer.io/v1'
const EXPENSE_REPORT_TRANSACTIONAL_MESSAGE_ID = '2'

const CUSTOMER_IO_APP_KEY = process.env.GATSBY_CUSTOMER_IO_APP_KEY

export const sendExpenseReportEmail = async ({
    to,
    subject,
    messageData,
    customerID,
    attachments = [],
}: SendExpenseReportEmailMethodProps) => {
    const payload = {
        to,
        subject,
        transactional_message_id: EXPENSE_REPORT_TRANSACTIONAL_MESSAGE_ID,
        message_data: messageData,
        identifiers: {
            id: customerID,
        },
        attachments: attachments?.reduce((acc: Record<string, string>, curr: Attachment) => {
            acc[curr.fileName] = arrayBufferToBase64(curr.data)
            return acc
        }, {}),
    }

    return ky
        .post(`${API_BASE_URL}/send/email`, {
            json: payload,
            headers: {
                Authorization: `Bearer ${CUSTOMER_IO_APP_KEY}`,
            },
        })
        .json()
}

const arrayBufferToBase64 = (arrayBuffer: ArrayBuffer) => {
    return btoa(
        new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
    )
}

type Attachment = {
    fileName: string
    data: ArrayBuffer
}

type SendExpenseReportEmailMethodProps = {
    to: string
    subject: string
    messageData: Record<string, any>
    customerID: string
    attachments?: Attachment[]
}
